import right from '../../../assets/images/production/dataAna/right.png'
import dataAna from '../../../assets/images/production/dataAna/dataAna.png'
import leftBall from '../../../assets/images/production/dataAna/left-ball.png'

import styles from './style.module.scss'

function DataAnalysisService() {
    return (
        <div className={`production-series-wrapper ${styles['data-ana-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">数据分析服务</div>
            </div>
            <div className={`series-container ${styles['series-container']}`}>
                <div className={`series-content ${styles['series-content']}`}>
                    <img src={leftBall} alt="" />
                    <div>
                        <div className={styles['series-left']}>
                            <div className={`introduction-title ${styles['introduction-title']}`}>
                                <p><span>数据分析服务</span></p>
                                <p>由数据分析团队为用户提供专业的一线数据分析服务，充分赋能数据深度分析、区域会战、专项建模、专题研究等工作场景。团队成员包括数据科学家、算法工程师、数据分析师，其中博士、硕士占比70%以上。</p>
                                <p>烽火星空数据分析团队扎根一线，用8年时间匠心打磨数据分析服务，将多年业务沉淀为独特方法论，辅助用户顺利开展业务，服务客户局点100余个，业务覆盖全国26个省及自治区。</p>
                            </div>
                        </div>
                        <div className={styles['series-right']}>
                            <img src={right} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['series-bottom']}>
                <img src={dataAna} alt="" />
            </div>
        </div>
    )
}

export default DataAnalysisService